// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class KeywordClick extends DataLayerEvent {
  validate(): boolean {
    return this.data.hasOwnProperty('keyword') && this.data.keyword.hasOwnProperty('list');
  }

  dispatch(): void {
    this.push({
      event: EventNames.CLICK_KEYWORD_IMPRESSION,
      ecommerce: {
        click: {
          actionField: { list: this.data.keyword.list },
          products: [this.data.keyword]
        }
      }
    });
  }
}
